import { type PropsWithChildren, useMemo } from "react";

import useIsMobileDetection from "@/hooks/useIsMobileDetection";

import MobileContentLayout from "./MobileContentLayout";
const DesktopContentLayout = ({ children }: PropsWithChildren) => {
  return (
    <div
      className="h-full min-h-0 relative"
      id="content-layout"
      data-testid="content-layout-desktop"
    >
      {children}
    </div>
  );
};

export default ({
  children,
  mobileThreshold,
}: PropsWithChildren<{
  mobileThreshold?: number;
}>) => {
  const isMobile = useIsMobileDetection(mobileThreshold);
  const Wrapper = useMemo(
    () => (isMobile ? MobileContentLayout : DesktopContentLayout),
    [isMobile],
  );

  return <Wrapper>{children}</Wrapper>;
};
